import { Label, TableCell, Tooltip, mergeClasses } from "@fluentui/react-components";
import * as React from "react";
import { ColumnSizingTableCellProps, IColumnDefinition } from "./PCSTableTypes";
import styles from "./PCSTable.module.scss";
export interface IPCSTableCellProps<T extends object> {
	column: IColumnDefinition<T>;
	item: T;
	sizing: ColumnSizingTableCellProps;
}

export function PCSTableCell<T extends object>({ column, item, sizing }: IPCSTableCellProps<T>) {
	const cellDiv = React.useRef<HTMLDivElement>(null);
	const [showTooltip, setShowTooltip] = React.useState(false);
	const hasOverflow = (cellDiv.current?.offsetWidth ?? 0) < (cellDiv.current?.scrollWidth ?? 0);
	const content: React.ReactNode = column.onRender ? (
		column.onRender(item)
	) : column.getValue ? (
		column.getValue(item)?.toString() ?? ""
	) : (
		<></>
	);

	return (
		<TableCell {...sizing} key={column.columnId}>
			<Tooltip
				relationship="description"
				positioning={"below"}
				visible={showTooltip}
				onVisibleChange={(ev, context) => {
					if (hasOverflow) {
						setShowTooltip(context.visible);
					} else {
						setShowTooltip(false);
					}
				}}
				content={<div>{content}</div>}>
				<div ref={cellDiv} className={mergeClasses(styles.tableCell, column.wrap && styles.wrap)}>
					{content}
				</div>
			</Tooltip>
		</TableCell>
	);
}
